import { render, staticRenderFns } from "./AdminTemplateEdit.vue?vue&type=template&id=49c34d09&scoped=true&"
import script from "./AdminTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./AdminTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdminTemplateEdit.vue?vue&type=style&index=0&id=49c34d09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c34d09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c34d09')) {
      api.createRecord('49c34d09', component.options)
    } else {
      api.reload('49c34d09', component.options)
    }
    module.hot.accept("./AdminTemplateEdit.vue?vue&type=template&id=49c34d09&scoped=true&", function () {
      api.rerender('49c34d09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminTemplateEdit.vue"
export default component.exports